var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.03,30.73c.49,.65,.9,1.37,1.47,1.94,7.03,7.07,14.09,14.11,21.13,21.16,.69,.69,1.43,1.2,2.46,1.16,1.18-.04,2.03-.6,2.55-1.62,.52-1.03,.42-2.06-.26-3.01-.23-.32-.52-.59-.8-.87-6.23-6.24-12.46-12.47-18.7-18.7-.24-.24-.51-.43-.85-.7,.34-.35,.57-.61,.82-.86,6.34-6.34,12.68-12.68,19.02-19.02,1.76-1.76,1.25-4.33-.98-5.05-1.11-.36-2.11-.11-2.94,.7-1.03,.99-2.03,2.01-3.04,3.02-6.13,6.13-12.26,12.24-18.37,18.39-.59,.59-1.02,1.33-1.53,2,0,.49,0,.97,0,1.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage20);
export default __webpack_public_path__ + "static/media/UDS Needs Image-20.a15cb86835f8d27304bb55c95ffe20bb.svg";
export { ForwardRef as ReactComponent };